<!-- 部门选择组件 -->
<template>
  <div class="body">
    <div class="content">
      <el-input v-model="dept.deptName" size="small" disabled></el-input>
      <el-button slot="right" :disabled="type===1" size="small" @click="showDialog">
        选择部门
      </el-button>
    </div>

    <el-dialog v-dialogDrag title="部门选择" :visible.sync="isShowDialog" width="30%" :before-close="closeDialog"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div style="height: 400px;">
        <el-tree ref="depTree" class="deptTree" :data="treeData" :accordion="true" :props="defaultProps"
          :expand-on-click-node="false" highlight-current node-key="deptId" :default-expand-all="true"
          @current-change="currentChange">
          <template #default="{ data }">
            <div style="display:flex;align-items:center">
              <slot :data="data">
                <img :src="icon" style=" margin-right: 6px" alt="部门图片" />
              </slot>
              <span style="font-size:14px">{{ data.deptName }}</span>
            </div>
          </template>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取 消</el-button>
        <el-button type="primary" size="small" @click="submitDept">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import orgFrameworkConfig from "@/CommonDP/service/org-service";
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    deptInfo: {
      type: Object,
      default: () => ({})
    },
    type: {
      // 0添加 1查看
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      treeData: [], // 树
      defaultProps: {
        children: "children",
        label: "deptName"
      },
      dept: {
        deptId: "",
        deptName: ""
      },
      selectData: {},
      isShowDialog: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  watch: {},
  created() {
    this.getTreeData();
    if (this.deptInfo) {
      this.setDeptInfo(this.deptInfo);
    }
  },
  mounted() {},
  methods: {
    // 返回人员列表
    getDeptInfo() {
      return this.dept;
    },
    setDeptInfo(deptInfo) {
      this.dept.deptId = deptInfo.deptId;
      this.dept.deptName = deptInfo.deptName;
    },
    async getTreeData() {
      const res = await orgFrameworkConfig.getOrgTree(this.enterpriseId);
      this.treeData = res.data || [];
      console.log(this.treeData);
    },
    currentChange(val, node) {
      console.log(val, node);
      this.selectData = val;
    },
    submitDept() {
      this.dept = this.selectData;
      console.log(this.dept);
      this.closeDialog();
    },
    showDialog() {
      this.isShowDialog = true;
    },
    closeDialog() {
      this.isShowDialog = false;
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  width: 100%;
  display: flex;
  align-items: center;
  .content {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .deptTree {
    overflow: auto;
    height: 400px;
  }
}
</style>
